export default "__VITE_ASSET__BJa2m$hg__"